import { PostMethod } from "../../methods/PostMethod";
import { ICreateChecklistResponse } from "../common/response.types";

export class CreateChecklistEndpoint extends PostMethod<ICreateChecklistResponse> {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}/checklists`);
  }
}
